import { useMemo } from 'react'

import { BufferTrackerReact as BufferTracker } from '@buffer-mono/tracking-plan'

import { useOrganizationId } from '~publish/contexts/AccountContext'

import { getCanvaChannel } from './config'
import type { ServiceForCanva } from './interface'

type TrackingMetadata = {
  organizationId: string
  clientName: string
  product: string
  channel: string
  designId?: string
}

export const useTrackingMetadata = (
  serviceId: ServiceForCanva,
  designId?: string,
): TrackingMetadata => {
  const organizationId = useOrganizationId() ?? ''
  return useMemo(
    () => ({
      organizationId,
      clientName: 'publishWeb',
      product: 'publish',
      channel: getCanvaChannel(serviceId),
      designId,
    }),
    [serviceId, designId, organizationId],
  )
}

const editTracking = {
  clicked: BufferTracker.canvaButtonEditClicked,
  published: BufferTracker.canvaDesignRepublished,
  attached: BufferTracker.canvaImageEditAttached,
  designOpen: BufferTracker.canvaDesignEditOpened,
  designClose: BufferTracker.canvaDesignEditClosed,
}

const createTracking = {
  clicked: BufferTracker.canvaButtonClicked,
  published: BufferTracker.canvaDesignPublished,
  attached: BufferTracker.canvaImageAttached,
  designOpen: BufferTracker.canvaDesignOpened,
  designClose: BufferTracker.canvaDesignClosed,
}

export const useTracking = (
  flow: 'edit' | 'create',
): typeof editTracking | typeof createTracking => {
  return flow === 'edit' ? editTracking : createTracking
}
